import { render, staticRenderFns } from "./ErpIcmDbBackupCheck.vue?vue&type=template&id=6d2c14ff&scoped=true&"
import script from "./ErpIcmDbBackupCheck.vue?vue&type=script&lang=js&"
export * from "./ErpIcmDbBackupCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c14ff",
  null
  
)

export default component.exports